// extracted by mini-css-extract-plugin
export default {"xsmall":"0","small":"480px","medium":"768px","large":"1024px","xlarge":"1440px","sitelarge":"1656px","xxlarge":"1920px"};